module.exports = __webpack_public_path__ + "static/media/tvshows-global-banner.342a3788.png";